import * as React from 'react';
import { useRecoilState } from 'recoil';
import { showSummariesAtom } from '../TripsOverviewState';
import useAnalytics from '../../../hooks/useAnalytics';

interface ISwitchProps {
  disabled?: boolean;
  tooltip?: string;
  changeCallback: (value: boolean) => void;
}

function SettingsSwitch(props: ISwitchProps): JSX.Element {
  const [showSummaries, setShowSummaries] = useRecoilState(showSummariesAtom);
  const { trackEvent } = useAnalytics();

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = !!event.currentTarget.checked;
    setShowSummaries(checked);
    props.changeCallback(checked);
    trackEvent(['ride book', 'click', 'Ride book toggle summaries']);
  };

  return (
    <div id="hhhh" className="e-checkbox-switch" title={props.tooltip || ''}>
      <label>
        <input
          type="checkbox"
          id="turn"
          name="turn"
          checked={showSummaries === true}
          disabled={props.disabled}
          onChange={handleOnChange}
          data-cy="ride-book-table-summaries-settings-switch"
        />
        <span />
      </label>
    </div>
  );
}

export default SettingsSwitch;
